import {
  SET_LOYALTY,
  SET_TRANSACTIONS_EARNED,
  SET_TRANSACTIONS_REDEEMED,
  SET_ACTIVE_VOUCHERS,
  SET_USED_VOUCHERS,
  // TODO: import action types added later
} from './types'

function setLoyaltyPoints(loyaltyPoints) {
  return {
    type: SET_LOYALTY,
    payload: {
      loyaltyPoints,
    },
  }
}

function setTransactionsEarned(transactionsEarned) {
  return {
    type: SET_TRANSACTIONS_EARNED,
    payload: {
      transactionsEarned,
    },
  }
}

function setTransactionsRedeemed(transactionsRedeemed) {
  return {
    type: SET_TRANSACTIONS_REDEEMED,
    payload: {
      transactionsRedeemed,
    },
  }
}

function setActiveVouchers(activeVouchers) {
  return {
    type: SET_ACTIVE_VOUCHERS,
    payload: {
      activeVouchers,
    },
  }
}

function setUsedVouchers(usedVouchers) {
  return {
    type: SET_USED_VOUCHERS,
    payload: {
      usedVouchers,
    },
  }
}
// TODO: add more action creators

export {
  setLoyaltyPoints,
  setTransactionsEarned,
  setTransactionsRedeemed,
  setActiveVouchers,
  setUsedVouchers,
  // TODO: export action creators added later
}
